import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSavedToken, isTokenExpired } from "../../utils/tokenHelper";
import { refreshToken } from "./authSlice";
import { customerView } from "@/services/customer";

export const fetchCustomerData = createAsyncThunk(
  "customer/fetchCustomerData",
  async (customerCode, { rejectWithValue, dispatch }) => {
    try {
      let tokenData = getSavedToken();

      if (!tokenData || isTokenExpired(tokenData)) {
        const newTokenAction = await dispatch(refreshToken());
        if (refreshToken.rejected.match(newTokenAction))
          throw new Error("Unable to refresh token");

        tokenData = newTokenAction.payload;
      }

      const res = await customerView(tokenData.access_token, customerCode);

      if (!res || Object.keys(res).length === 0)
        throw new Error("Empty response received from server");

      if (!res.customer)
        throw new Error("Customer data not found in API response");

      return {
        customer: res.customer,
        walletsDetail: res.walletsDetail,
        transactions: res.transactions,
        tierHistory: res.tierHistory,
        WalletSummary: res.WalletSummary,
        activityLogs: res.activityLogs
      };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const customerSlice = createSlice({
  name: "customer",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {
    clearCustomerData: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
    updateCustomerPoints: (state, action) => {
      if (state.data?.walletsDetail) {
        state.data.walletsDetail.TotalavailableValue = action.payload;
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCustomerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCustomerData, updateCustomerPoints } =
  customerSlice.actions;

export default customerSlice.reducer;
